
import Certificates from './list'
import PdfPaper from './pdf'

export {PdfPaper}
export default  Certificates